import React from 'react'
import Image from "../assets/img/about.jpg"
import { useTheme } from '../Context/ThemeContext';

function AboutImg() {

    const { theme, selectedColor, colors } = useTheme();

    return (
        <div className='relative flex transition ease-in duration-300 hover:-translate-y-2 group'>
            <img src={Image} alt="about" className={`h-40 w-40 md:h-52 md:w-52 rounded-md z-10`} />
            <div className={`h-40 w-40 md:h-52 md:w-52 border-2 rounded-md absolute top-6 left-6 transition ease-in duration-300 ${colors[theme].colors[selectedColor].borderSecondary} group-hover:${colors[theme].colors[selectedColor].borderPrimary}`}></div>
        </div>
    )
}

export default AboutImg